module.exports = __webpack_public_path__ + "static/img/dynamic.9e156593.png";